import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDUoVIyrkNsl-8MqvPljt0OAnNLStuqm3E",
  authDomain: "mosses-77764.firebaseapp.com",
  projectId: "mosses-77764",
  storageBucket: "mosses-77764.appspot.com",
  messagingSenderId: "291770956275",
  appId: "1:291770956275:web:ad1f53f2f9e929236eba86"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage();
const auth = getAuth();

export { db, storage, auth }